export default "__VITE_PUBLIC_ASSET__97ac4ff0__"